<admin-layout
    pageTitle="Reprodutores"
    searchPlaceholder="Nome, código, registro ou apelido"
    [showSearch]="true"
    (searchChange)="onSearchChange($event)"
>
    <div actions>
        <button mat-icon-button (click)="syncBreeders()" aria-label="Sincronizar reprodutores">
            <mat-icon>sync</mat-icon>
        </button>
    </div>
    <div class="status-filter" role="group" aria-label="Situação">
        <button type="button" [class.on]="actives === Actives.TRUE" (click)="setActives(Actives.TRUE)">Ativos</button>
        <button type="button" [class.on]="actives === Actives.FALSE" (click)="setActives(Actives.FALSE)">Inativos</button>
        <button type="button" [class.on]="actives === Actives.ALL" (click)="setActives(Actives.ALL)">Todos</button>
    </div>
    <entity-cards
        #list
        [repository]="repository"
        [perspective]="perspective"
        [searchTerm]="search"
        [summary]="true"
    >
        <mat-card class="entityCard admin-entity-card" *entityCard="let entity">
            <div class="card-accent"></div>
            <div class="card-body breeders">
                <div class="info-item code">
                    <span class="info-label">Registro</span>
                    <span class="info-value">{{ getRegister(entity) }}</span>
                </div>
                <div class="info-item name">
                    <span class="info-label">Nome</span>
                    <span class="info-value" [title]="displayName(entity)">{{ displayName(entity) }}</span>
                </div>
                <div class="info-item nick">
                    <span class="info-label">Apelido</span>
                    <span class="info-value" [title]="getNickname(entity)">{{ getNickname(entity) }}</span>
                </div>
                <div class="info-item company">
                    <span class="info-label">Empresa</span>
                    <span class="info-value" [title]="getCompany(entity)">{{ getCompany(entity) }}</span>
                </div>
            </div>
            <div class="card-meta">
                <span
                    class="chip"
                    [class.chip-ok]="entity?.isActive"
                    [class.chip-off]="!entity?.isActive"
                >
                    {{ getStatusLabel(entity) }}
                </span>
                <button
                    type="button"
                    class="act"
                    (click)="toggleActive(entity)"
                    [disabled]="busyId === entity?.id"
                >
                    {{ entity?.isActive ? 'Inativar' : 'Ativar' }}
                </button>
            </div>
        </mat-card>
    </entity-cards>
</admin-layout>
@if (isSyncing) {
<div class="sync-overlay">
    <mat-spinner diameter="60"></mat-spinner>
    <h2><strong>Sincronizando dados...</strong></h2>
</div>
}
